// keep equal to server/constants/flashcardTypes.js
export const FLASHCARD_TYPE_CODING = 'Coding';
export const FLASHCARD_TYPE_ENUMERATION = 'Enumeration';
export const FLASHCARD_TYPE_IMAGEPOS = 'Image Position';
export const FLASHCARD_TYPE_IMAGE = 'Image';
export const FLASHCARD_TYPE_SIMPLE = 'Simple';
export const FLASHCARD_TYPE_VOCABLE = 'Vocable';
export const FLASHCARD_TYPE_DATE = 'Date';
export const FLASHCARD_TYPE_QUIZ = 'Quiz';

export const IMAGEPRESENTATION_TYPE_ALL = 'All';
export const IMAGEPRESENTATION_TYPE_RANDOM = 'Random';
export const IMAGEPRESENTATION_TYPE_FIRST = 'First';
